import { Stack, Title } from "@mantine/core";

import { getFileAttachmentId } from "../../utils";
import { FileItem, FileItemProps } from "../FileItem";

import type { FC } from "react";
import type { FileAttachment } from "../../types";

export type FileListProps = {
  disabled?: boolean;
  files: FileAttachment[];
  labels?: FileItemProps["labels"];
  onChange?: (index: number, file: Partial<FileAttachment>) => void;
  onDelete?: (index: number) => void;
  title?: string;
  types?: FileItemProps["types"];
};

export const FileList: FC<FileListProps> = ({
  disabled = false,
  files,
  labels,
  onChange,
  onDelete,
  title,
  types,
}) => {
  return (
    <Stack gap="md">
      {files.length > 0 && title && (
        <Title fw="bold" order={5}>
          {title}
        </Title>
      )}
      {files.map((file, index) => (
        <FileItem
          key={getFileAttachmentId(file)}
          disabled={disabled}
          file={file}
          labels={labels}
          onChange={(file) => onChange?.(index, file)}
          onDelete={onDelete ? () => onDelete(index) : undefined}
          types={types}
        />
      ))}
    </Stack>
  );
};
